import { __extends } from "tslib";
var UnknownChannelModeCharError = /** @class */ (function (_super) {
    __extends(UnknownChannelModeCharError, _super);
    function UnknownChannelModeCharError(_char) {
        var _this = _super.call(this, "Unknown channel mode character " + _char) || this;
        _this._char = _char;
        Object.setPrototypeOf(_this, UnknownChannelModeCharError.prototype);
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, UnknownChannelModeCharError);
        }
        return _this;
    }
    Object.defineProperty(UnknownChannelModeCharError.prototype, "char", {
        get: function () {
            return this._char;
        },
        enumerable: false,
        configurable: true
    });
    return UnknownChannelModeCharError;
}(Error));
export { UnknownChannelModeCharError };
